import type { AxiosResponse } from "axios";
import { isAxiosError } from "axios";

import type { ApiResponse, BusinessLogicErrorResponse, ErrorResponse, ErrorResult } from "~/api/apiResponseTypes.ts";
import { ApiResponseErrorType } from "~/api/apiResponseTypes.ts";

export const getDataFromResponse = <T>(res: AxiosResponse<ApiResponse<T>>): T => res.data.data;

function isBusinessLogicError(data: unknown): data is BusinessLogicErrorResponse {
	return typeof data === "object" && data !== null && "reason" in data;
}

export function handleApiError(error: unknown): ErrorResult {
	if (isAxiosError(error)) {
		const errorCode = error.response?.status || 0;
		const responseData = error.response?.data;

		if (isBusinessLogicError(responseData)) {
			return {
				type: ApiResponseErrorType.BUSINESS_LOGIC,
				code: errorCode,
				reason: responseData.reason,
				data: responseData,
			};
		}

		if (errorCode === 422) {
			const validationErrors: ErrorResponse = responseData ?? { errors: {} };

			return {
				type: ApiResponseErrorType.VALIDATION,
				code: errorCode,
				messages: validationErrors.errors,
			};
		}

		return {
			type: ApiResponseErrorType.AXIOS,
			code: errorCode,
			message: error.message,
		};
	}

	return {
		type: ApiResponseErrorType.UNKNOWN,
		message: String(error),
	};
}